import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const VisibilityBlankDark: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ size = 24, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 98 125"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M32.7566 12.8771L11.4543 24.9057V20.5241C11.1157 17.7708 11.4231 14.9826 12.3541 12.3606C13.2852 9.73869 14.8176 7.35749 16.8311 5.39651C18.8446 3.43115 21.2947 1.93853 23.9898 1.0237C26.6804 0.113239 29.5581 -0.197542 32.3957 0.121994H60.438C63.2711 -0.197542 66.1444 0.113239 68.8395 1.0237C71.5346 1.93853 73.9802 3.43115 75.9937 5.39213C78.0072 7.35312 79.5396 9.72993 80.4706 12.3475C81.4017 14.9651 81.7135 17.7533 81.3794 20.5022V24.8225L60.0771 12.8509C55.8808 10.6404 51.1856 9.48481 46.4146 9.48919C41.6437 9.48919 36.9484 10.6579 32.7566 12.8728V12.8771Z"
          fill="#45D88E"
        />
        <path
          d="M82.3701 35.3072L81.5383 34.8326L73.2691 30.0873L56.2029 20.2608C53.3586 18.7745 50.1967 18 46.9811 18C43.7656 18 40.6037 18.7745 37.7593 20.2608L20.6932 30.0873L12.4239 34.8774L11.3551 35.4818C0.720034 42.5774 0 43.8802 0 55.3049V82.5818C0 94.002 0.715562 95.3048 11.5966 102.584L37.7593 117.639C40.5813 119.184 43.7611 119.954 46.9811 119.882C50.2012 119.94 53.3809 119.157 56.2029 117.617L82.6027 102.405C93.2467 95.3048 93.9623 94.002 93.9623 82.5863V55.3094C93.9623 43.8847 93.2467 42.5819 82.3657 35.3116L82.3701 35.3072Z"
          fill="#1B3029"
        />
      </svg>
    )
  },
)

VisibilityBlankDark.displayName = 'VisibilityBlankDark'
